var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.305 1.506a1.884 1.884 0 0 0-1.336.568L9.973 9.187 8.93 13.57l4.383-1.043.152-.14 6.967-6.856a1.9 1.9 0 0 0 .011-2.69l-.785-.79a1.87 1.87 0 0 0-1.353-.545Zm.011 1.488c.1 0 .2.041.282.123l.785.785a.383.383 0 0 1 0 .563l-6.82 6.703-1.618.387.387-1.618 6.709-6.82a.375.375 0 0 1 .275-.123ZM4.5 3c-1.658 0-3 1.342-3 3v12c0 1.658 1.342 3 3 3h12c1.658 0 3-1.342 3-3V8.555L18 10.03V18c0 .826-.674 1.5-1.5 1.5h-12c-.826 0-1.5-.674-1.5-1.5V6c0-.826.674-1.5 1.5-1.5h7.98L13.957 3H4.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export default ForwardRef;